import React from 'react'
import { Tag } from '@/shared/ui/components/Tag'
import { LogRow, LogTime, LogType, LogMessage } from './styled'
import { Badge } from '@/shared/ui/components/Badge'
import { Flex } from 'antd'
import { useBreakpoint } from '@/app/hooks/useBreakpoint'
import { TaskLog } from '@/entities/task/model/taskTypes'

const getBadgeStatus = (type: TaskLog['type']) => {
  switch (type) {
    case 'info':
      return 'default'
    case 'warning':
      return 'warning'
    case 'error':
      return 'error'
    case 'access':
      return 'success'
    default:
      return 'default'
  }
}

const getTagStatus = (type: TaskLog['type']) => {
  switch (type) {
    case 'info':
      return 'accent'
    case 'warning':
      return 'attention'
    case 'error':
      return 'danger'
    case 'access':
      return 'done'
    default:
      return 'accent'
  }
}

const getTypeLabel = (type: TaskLog['type']) => {
  if (type === 'access') return 'Accesses'
  return type.charAt(0).toUpperCase() + type.slice(1)
}

export interface LogProps {
  log: TaskLog
}

export const Log: React.FC<LogProps> = ({ log }) => {
  const { isSm, isXs } = useBreakpoint()

  const isMobile = isXs || isSm
  return (
    <LogRow
      align={isMobile ? 'inherit' : 'center'}
      gap={8}
      type={log.type}
      vertical={isMobile}
    >
      <Flex
        align="center"
        gap={8}
        justify={isMobile ? 'space-between' : 'inherit'}
      >
        <Flex align="center" gap={8}>
          <Badge status={getBadgeStatus(log.type)} />
          <LogTime type="secondary">{log.time}</LogTime>
        </Flex>
        <LogType>
          <Tag size="medium" variant={getTagStatus(log.type)}>
            {getTypeLabel(log.type)}
          </Tag>
        </LogType>
      </Flex>
      <LogMessage>{log.message}</LogMessage>
    </LogRow>
  )
}

export default Log
